const adminHeaders = [
    {
      id: "cuil",
      numeric: false,
      disablePadding: false,
      label: "CUIL",
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "NOMBRE",
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: "EMAIL",
    },
  ];

  export default adminHeaders